export const routes = {
  SIGNIN: "/auth/signin",
  SIGNUP: "/auth/signup",
  TERMS: "/auth/terms",
  RESET_PASSWORD: "/auth/reset-password",
  ENTER_NEW_PASSWORD: "/auth/confirm-password/:token?",

  HAULPAY_JOIN: "/haul-pay/join",
  HAULPAY_STATUS: "/haul-pay",
  HAULPAY_UPLOAD_DOCS: "/haul-pay/upload-docs",

  USER: "/user",

  SAVED_POSTS: "/saved",
  SAVED_TRUCKS: "/saved/trucks",
  SAVED_LOADS: "/saved/loads",

  SETTINGS: "/settings",
  SETTINGS_ACCOUNT: "/settings/account",
  SETTINGS_PROFILE: "/settings/profile",
  SETTINGS_PROFILE_USER: "/settings/profile/user-profile",
  SETTINGS_NOTIFICATIONS: "/settings/notifications",
  SETTINGS_BILLING: "/settings/billing",
  SETTINGS_BILLING_RECEIPT: "/settings/billing/receipt",
  SETTINGS_HELP: "/settings/help",
  SETTINGS_THEME: "/settings/theme",
  SETTINGS_API: "/settings/api",
  SETTINGS_INTEGRATIONS: "/settings/integrations",
  SETTINGS_INTEGRATIONS_API: "/settings/integrations/api",
  SETTINGS_INTEGRATIONS_ALVYS: "/settings/integrations/alvys",
  SETTINGS_BANK_ACCOUNT: "/settings/bank-account",

  BANK_UPDATE: "/bank/:target",

  HAULPAY: "/haulpay",

  HAULPAY_ASSIGNED_LOADS: "/haulpay/assigned-loads",
  HAULPAY_ASSIGNED_LOADS_PAYMENT_DETAILS: "/haulpay/assigned-loads/payment-details",

  HAULPAY_CARRIER_REQUEST_PAY: "/haulpay/request-pay",
  HAULPAY_CARRIER_REQUEST_PAY_FUNDING_REQUEST: "/haulpay/request-pay/funding-request",
  HAULPAY_CARRIER_MANAGE_PAY: "/haulpay/carrier/manage-pay",
  HAULPAY_CARRIER_FUNDING_REQUEST: "/haulpay/carrier/funding-request",
  HAULPAY_CARRIER_FUNDING_REQUEST_V2: "/haulpay/carrier/funding-request-v2",
  HAULPAY_CARRIER_HISTORY_IN_PROCESS: "/haulpay/carrier/manage-pay/in-process",
  HAULPAY_CARRIER_MANGE_PAY_PAYMENT_DETAILS: "/haulpay/carrier/manage-pay/payment-details",
  HAULPAY_CARRIER_PAYMENT_PREFERENCE: "/haulpay/carrier/connection",
  HAULPAY_CARRIER_BULK_UPLOADS: "/haulpay/carrier/bulk-uploads",

  HAULPAY_BROKER_MANAGE_PAY: "/haulpay/broker/manage-pay",
  HAULPAY_BROKER_FUNDING_REQUEST: "/haulpay/broker/funding-request",
  HAULPAY_BROKER_FUNDING_REQUEST_V2: "/haulpay/broker/funding-request-v2",
  HAULPAY_BROKER_WALLET: "/haulpay/broker/wallet",
  HAULPAY_BROKER_WALLET_PENDING: "/haulpay/broker/wallet/pending",
  HAULPAY_BROKER_WALLET_HISTORY: "/haulpay/broker/wallet/history",
  HAULPAY_BROKER_STRIPE_ONBOARDING_SUCCESS: "/haulpay/broker/wallet/onboarding-success",
  HAULPAY_BROKER_BULK_UPLOADS: "/haulpay/broker/bulk-uploads",
  HAULPAY_BROKER_RECEIVABLES: "/haulpay/broker/receivables",
  HAULPAY_BROKER_REPORTS: "/haulpay/reports",
  HAULPAY_BROKER_REPORTS_PAST_REPORTS: "/haulpay/broker/past-reports",
  HAULPAY_BROKER_CARRIERS: "/haulpay/broker/carriers",
  HAULPAY_BROKER_CARRIERS_ORIGIN: "/haulpay/broker/carriers/origin",
  HAULPAY_BROKER_CARRIERS_NEW: "/haulpay/broker/carriers/add",
  HAULPAY_BROKER_CARRIERs_NEW_FLOW: "/haulpay/broker/carriers/add/flow",
  HAULPAY_BROKER_INVITED_CARRIER: "/haulpay/broker/carriers/invited",

  HAULPAY_CREDIT: "/haulpay/credit",
  HAULPAY_CREDIT_CHECK_CREDIT: "/haulpay/credit/check",
  HAULPAY_CREDIT_MY_CUSTOMERS: "/haulpay/credit/customers",

  TRUCKS: "/trucks",
  TRUCKS_SEARCH: "/trucks/search",
  TRUCKS_POST: "/trucks/post",
  TRUCKS_MY_POSTED: "/trucks/my-posted",
  TRUCKS_MATCHES_LIST: "/trucks/my-posted/:truckId/matches",

  HOME: "/home",
  HOME_CARD_SETTINGS: "/home/card-settings",

  LOADS: "/loads",
  LOADS_SEARCH: "/loads/search",
  LOADS_POST: "/loads/post",
  LOADS_POSTED_ALL: "/loads/post/all",
  LOADS_POSTED_HAULPAY: "/loads/post/haulpay",
  LOADS_POSTED_CREATE: "/loads/post/create",
  LOADS_CREATE_FUNDING_REQUEST: "/loads/post/create/funding-request",
  LOADS_CREATE_FUNDING_REQUEST_SEARCH: "/loads/post/create/funding-request/search",

  RATE_TREND: "/rate-trend",
  RATE_TREND_GRAPH: "/rate-trend/graph"
};

interface IUploadDocumentProps {
  factoring_id?: string;
  funding_request_id?: string;
  payment_profile_id?: string;
  file_id?: string;
}

export const UPLOAD_DOCUMENT_URLS = ({
  factoring_id,
  funding_request_id,
  payment_profile_id
}: IUploadDocumentProps) => {
  return {
    FR_ATTACHMENT: `upload/fr_attachment/factoring/${factoring_id}/funding_request/${funding_request_id}/file`,
    CUSTOMER: `upload/relationship_attachment/relationship/${factoring_id}/file`,
    FACTORING: `upload/factoring_attachment/factoring/${factoring_id}/file`,
    NEW_CARRIER: `upload/payment_profile_attachment/payment_profile/${payment_profile_id}/file`,
    MY_CUSTOMER: `upload/factoring_debtor_relationship_attachment/relationship/${factoring_id}/file`,
    NEW_CUSTOMER: `upload/admin_debtor_note_attachment/debtor`
  };
};
